import React from "react";
import { useTranslation } from "react-i18next";
import { MdGridView, MdTableRows } from "react-icons/md";
import SegmentedControl from "../../../../../../Components/UI/SegmentedControl/SegmentedControl";

const VIEW_OPTIONS = [
  { value: "cards", label: "Cards", i18nKey: "carriers.view.cards", icon: MdGridView },
  { value: "list", label: "List", i18nKey: "carriers.view.list", icon: MdTableRows },
];

// Cards / List switch. Desktop only: phones always get the compact rows.
const ViewSwitch = ({ value, onChange, ariaLabel }) => {
  const { t } = useTranslation("settings");
  const options = VIEW_OPTIONS.map(({ i18nKey, ...option }) => ({
    ...option,
    label: t(i18nKey, { defaultValue: option.label }),
  }));
  return (
    <div className="hidden sm:flex">
      <SegmentedControl options={options} value={value} onChange={onChange} ariaLabel={ariaLabel} />
    </div>
  );
};

export default ViewSwitch;
